/**
 * Is "Record one payment for many invoices" on (#1916)? Settings →
 * Organization; missing = ON. Every entry point checks this AND the
 * payments.manage permission. Mark Paid never does — it stays either way.
 */
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { PERMISSIONS } from "@/lib/permissions";

export const RECORD_MANY_KEY = "payments.record_many_invoices";
export const RECORD_MANY_QUERY_KEY = ["received-payments-setting"] as const;

export function useRecordMany(): boolean {
    const { can, isAdmin } = useAuth();
    // Screens mounted in tests (or old auth shapes) may not carry `can`.
    const allowed = Boolean(isAdmin) || (typeof can === "function" && can(PERMISSIONS.payments.manage));
    const q = useQuery({
        queryKey: RECORD_MANY_QUERY_KEY,
        queryFn: () => api.get<{ on: boolean }>("/api/received-payments/setting"),
        enabled: allowed,
        staleTime: 60_000,
    });
    return allowed && q.data?.on === true;
}

/** Where every door opens: the Record a payment screen, customer and invoices filled in. */
export function recordPaymentHref(customerId?: string | null, invoiceIds: string[] = []): string {
    const p = new URLSearchParams();
    if (customerId) p.set("customerId", customerId);
    if (invoiceIds.length > 0) p.set("invoiceIds", invoiceIds.join(","));
    const qs = p.toString();
    return `/money/payments/new${qs ? `?${qs}` : ""}`;
}
